import { render, staticRenderFns } from "./DeltaCell.vue?vue&type=template&id=74836d94&"
import script from "./DeltaCell.vue?vue&type=script&lang=js&"
export * from "./DeltaCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports